import React from "react";
import JBKycDocumentsComponent from "./JBKycDocumentsComponent";
import JBProofUploadComponent from "./JBProofUploadComponent";
import NIBiddingApplicationForm from "../NIBiddingApplicationForm";
import NITermsAndConditions from "../NITermsAndConditions";
import JBESignComponent from "./JBESignComponent";
import JBCompletedStepsComponent from "./JBCompletedStepsComponent";

interface JointIndividualOnlinePrimaryKycStepContentProps {
  activeStep: number;
  bidderUuid: any;
  bidder: any;
  setActiveStep: any;
  init: any;
  offlinePaymentValidation: boolean;
  stepsTitles: Array<{ label: string; value: string }>;
}

export default function JointIndividualOnlinePrimaryKycStepContent({
  activeStep,
  bidderUuid,
  bidder,
  setActiveStep,
  init,
  offlinePaymentValidation,
  stepsTitles,
}: JointIndividualOnlinePrimaryKycStepContentProps) {
  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return (
          <JBKycDocumentsComponent
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        );
      case 1:
        return (
          <JBProofUploadComponent
            bidderUuid={bidderUuid}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        );
      case 2:
        return (
          <NIBiddingApplicationForm
            bidderUuid={bidderUuid}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
            bidder={bidder}
            outerNextStep="bid_details"
          />
        );
      case 3:
        return (
          <NITermsAndConditions
            bidderUuid={bidderUuid}
            bidder={bidder}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        );
      case 4:
        return (
          <JBESignComponent
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        );
      case 5:
        return (
          <JBCompletedStepsComponent
            bidderUuid={bidderUuid}
            bidder={bidder}
            stepsTitles={stepsTitles}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            init={init}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="p-2 md:p-4 bg-white">
      {renderStepContent()}
    </div>
  );
}

